<i18n>
{
  "cl":{
    "error-getProspectList": "Ocurrió un error al tratar de obtener los prospectos.",
    "filterResult":"Para este filtro hay",
    "descargarCSV": "Descargar CSV",
    "error-zipcelx": "Hubo un problema al exportar el documento",
    "button-manage":"Ver",
    "brokerProspect": "Lead de broker",
    "brokerSource": "Origen del lead",
    "no-offer": "sem oferta"
  },
  "pe":{
    "error-getProspectList": "Ocurrió un error al tratar de obtener los prospectos.",
    "filterResult":"Para este filtro hay",
    "descargarCSV": "Descargar CSV",
    "error-zipcelx": "Hubo un problema al exportar el documento",
    "button-manage":"Ver",
    "brokerProspect": "Lead de broker",
    "brokerSource": "Origen del lead",
    "no-offer": "sin oferta"
  },
  "br":{
    "error-getProspectList": "Ocorreu um erro ao tentar obter os leads.",
    "filterResult":"Para este filtro existe",
    "descargarCSV": "Download CSV",
    "error-zipcelx": "Ocorreu um problema ao exportar o documento",
    "button-manage":"Ver",
    "brokerProspect": "Lead do Broker",
    "brokerSource": "Fonte do lead",
    "no-offer": "sem oferta"
  }
}
</i18n>
<template>
  <div>
    <h2 class="grand-size-text leads">Leads</h2>
    <div class="card-item">
      <div class="columns mx-auto is-multiline header-btn">
        <div class="column is-10-until-widescreen">
          <!-- <div v-if="prospects.length > 0 && !isLoading"> -->
          <div class="columns is-multiline header-btn">
            <div class="column is-10-until-widescreen">
              <FindLeadsInput placeholder="Buscar leads" :expanded="true" class="search-leads" @select="goToSingleProspectView($event._id)" />
            </div>
            <div class="column is-10-until-widescreen">
              <b-button id="download-csv-leads" :loading="CSVisLoading" @click="getCSVProspects()">{{ $t('descargarCSV') }}</b-button>
            </div>
          </div>
          <div>
            <LeadsFilters v-model="filters" @input="loadProspects('newFilterSelected')" />
            <h5 class="has-text-centered">
              {{ $t('filterResult') }} <span class="has-text-wight-bold">{{ pagination.numberOfDocuments }} lead{{ prospects.length > 1 ? 's' : '' }}.</span>
            </h5>
          </div>
          <!-- </div> -->
          <div class="container">
            <Spinner v-if="isLoading" />
            <Message v-if="prospects.length === 0 && !isLoading" :message="mainMessage.message" :icon="mainMessage.icon" :as-card="false" />
            <div v-if="!isLoading" class="default-item" data-cy="lead-container">
              <div v-for="prospect in prospects" :key="prospect._id" class="card-item shadowless has-text-centered default-item-info med-size-text my-3">
                <div class="default-item-prospect-broker">
                  <span class="default-item-name content-title">
                    {{ prospect.name }} {{ prospect.lastName }}
                  </span>
                  <span v-if="prospect.hasOffer === false" class="no-offer-tag creditu-tag">{{ $t('no-offer') }}</span>
                  <span v-if="prospect.brokerId" class="prospect-broker-tag creditu-tag is-hidden-tablet is-hidden-desktop">Broker</span>
                  <span v-if="prospect.brokerSource" class="prospect-broker-tag creditu-tag is-hidden-tablet is-hidden-desktop">{{ prospect.brokerSource.name }}</span>
                  <b-tooltip
                    v-if="prospect.brokerId"
                    class="prospect-broker-tag-tooltip creditu-tag is-hidden-mobile"
                    :label="$t('brokerProspect')"
                    position="is-right">
                    <span class="prospect-broker-tag creditu-tag">Broker</span>
                  </b-tooltip>
                  <b-tooltip
                    v-if="prospect.brokerSource"
                    class="prospect-broker-tag-tooltip creditu-tag is-hidden-mobile"
                    :label="$t('brokerSource')"
                    position="is-right">
                    <span class="broker-source-tag creditu-tag">{{ prospect.brokerSource.name }}</span>
                  </b-tooltip>
                </div>
                <span class="default-item-idnumber">
                  {{ prospect.idNumber }}
                </span>
                <span v-if="prospect.lastInteractionDate" class="default-item-date">
                  <i class="fas fa-history has-text-primary" /> {{ formatDate(prospect.lastInteractionDate, 'DD/MM/YY HH:mm') }}
                </span>
                <span v-else class="default-item-date">
                  <i class="fas fa-history has-text-primary" /> {{ formatDate(prospect.createdAt, 'DD/MM/YY HH:mm') }}
                </span>

                <span class="default-item-stage">
                  {{ $t(`prospectStatus.${prospect.status}`) }}<br>{{ $t(`prospectSubStatus.${prospect.subStatus}`) }}
                </span>
                <button :id="`prospect-${prospect._id}`" class="button manage-button is-button-secondary is-rounded is-fullwidth-mobile" @click="goToSingleProspectView(prospect._id)">
                  <span>
                    {{ $t('button-manage') }}
                  </span>
                </button>
              </div>
            </div>
            <CredituPagination
              v-if="!isLoading && prospects.length > 0"
              :documents-per-page.sync="pagination.documentsPerPage"
              :total="pagination.numberOfDocuments"
              :page-number.sync="pagination.pageNumber"
              size="is-small"
              items-name="Leads"
              :range-before="1"
              :range-after="1"
              :documents-per-page-options="[5, 10, 20, 50]"
              @update:documentsPerPage="catchUpdatePagination('setPaginationDocumentsPerPage',$event)"
              @update:pageNumber="catchUpdatePagination('setPaginationPageNumber',$event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zipcelx from 'zipcelx';
import { now, dateToFormatedString } from '@/infrastructure/date';
import Spinner from '@/ui/components/Spinner.vue';
import Message from '@/ui/components/Message.vue';
import FindLeadsInput from '@/ui/components/internal/leads/FindLeadsInput.vue';
import { getProspectList, getProspectListCSV } from '@/application/services/api-clients/prospects-leads';
import CredituPagination from '@/ui/components/CredituPagination.vue';
import LeadsFilters from '@/ui/components/internal/leads/LeadsFilters.vue';

export default {
  name: 'Leads',
  components: {
    Spinner,
    Message,
    FindLeadsInput,
    CredituPagination,
    LeadsFilters
  },
  data() {
    return {
      prospects: [],
      isLoading: false,
      CSVisLoading: false,
      mainMessage: {
        message: '',
        icon: ''
      },
      cancelLoadProspectRequest: null,
      cancelledRequestMessage: 'cancelled',
      prospectsToCSV: [],
      headersCSV: []
    };
  },
  computed: {
    pagination() {
      return this.$store.state.leadsModule.pagination;
    },
    filters: {
      get() {
        return this.$store.state.leadsModule.filters;
      },
      set(filterObject) {
        this.$store.dispatch('setFilters', filterObject);
      }
    }
  },
  mounted() {
    this.loadProspects();
  },
  methods: {
    async getProspectList(getProspectListInput) {
      let response = null;
      try {
        response = await getProspectList(
          getProspectListInput,
          cancelFunction => { this.cancelLoadProspectRequest = cancelFunction; }
        );
      } catch (error) {
        if (error.message !== this.cancelledRequestMessage) {
          this.mainMessage = {
            message: this.$t('error-getProspectList'),
            icon: 'data_maintenance.svg'
          };
          this.isLoading = false;
        }
      }
      return response;
    },
    async getProspectListCSV(getProspectListInput) {
      let response = null;
      try {
        response = await getProspectListCSV(
          getProspectListInput,
          cancelFunction => { this.cancelLoadProspectRequest = cancelFunction; }
        );
      } catch (error) {
        if (error.message !== this.cancelledRequestMessage) {
          this.mainMessage = {
            message: this.$t('error-getProspectList'),
            icon: 'data_maintenance.svg'
          };
          this.isLoading = false;
        }
      }
      return response;
    },
    goToSingleProspectView(prospectId) {
      this.$router.push(`leads/${prospectId}`);
    },
    async loadProspects(callReason) {
      if (callReason && callReason === 'newFilterSelected') {
        /** Se va a pedir la página 1 del nuevo filtro */
        this.$store.dispatch('setPaginationPageNumber', 1);
      }
      if (this.isLoading) {
        this.cancelLoadProspectRequest(this.cancelledRequestMessage);
      }
      this.isLoading = true;
      const paramsGetProspectList = {
        ...this.pagination,
        filters: this.filters
      };
      try {
        const result = await this.getProspectList(paramsGetProspectList);
        if (result !== null && result.prospects) {
          this.prospects = result.prospects;
          this.brokerSource = result?.prospects;
          this.$store.dispatch('setCurrentPagination', result.pagination || {});
        } else {
          this.prospects = [];
          this.$store.dispatch('setCurrentPagination', { numberOfDocuments: 0, documentsPerPage: paramsGetProspectList.documentsPerPage, pageNumber: 1 });
        }
        this.isLoading = false;
      } catch (_error) {
        /** Llamada al backend retorna un error */
        this.isLoading = false;
        this.$store.dispatch('setCurrentPagination', { numberOfDocuments: 0 });
        this.prospects = [];
      }
    },
    async getCSVProspects() {
      if (this.CSVisLoading) {
        this.cancelLoadProspectRequest(this.cancelledRequestMessage);
      }
      this.CSVisLoading = true;
      const paramsGetProspectList = { filters: this.filters };
      try {
        const result = await this.getProspectListCSV(paramsGetProspectList);
        if (result !== null && result.prospects) {
          this.prospectsToCSV = result.prospects || [];
          this.headersCSV = result.csvHeaders || [];
          // creo el csv solo si obtuve algo
          this.downloadExcel();
        }
      } catch (_error) {
        /** TODO: error */
      } finally {
        this.CSVisLoading = false;
      }
    },
    downloadExcel() {
      const rows = this.prospectsToCSV;
      const headerRow = this.headersCSV;
      const config = {
        filename: `Prospectos ${now('DD-MM-YY-HH-mm')}`,
        sheet: {
          data: [
            headerRow.map(value => (
              { value: this.$t(`leadsCsvColumnTitles.${value}`), type: 'string' }
            ))
          ]
        }
      };
      rows.forEach(prospectRow => {
        const excelRowValues = [];
        headerRow.forEach(headerTitle => {
          let value = prospectRow[headerTitle] || '';
          if (headerTitle === 'status' && value !== '') {
            value = this.$t(`prospectStatus.${value}`);
          } else if (headerTitle === 'subStatus' && value !== '') {
            value = this.$t(`prospectSubStatus.${value}`);
          }
          excelRowValues.push({ value, type: typeof value });
        });
        config.sheet.data.push(excelRowValues);
      });
      try {
        zipcelx(config);
      } catch (_error) {
        this.alert({ message: this.$t('error-zipcelx') });
      }
    },
    catchUpdatePagination(prop, value) {
      if (prop === 'setPaginationDocumentsPerPage') {
        this.$store.dispatch('setPaginationPageNumber', 1);
      }
      this.$store.dispatch(prop, value);
      this.loadProspects();
    },
    formatDate: (date, format = 'DD/MM/YYYY') => dateToFormatedString(date, format)
  }
};
</script>

<style>
.default-item-prospect-broker{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
}
.creditu-tag {
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  padding: 0px 10px;
  text-align: center;
}
.prospect-broker-tag{
  background: var(--color-nickel);
  color: #fff;
}
.broker-source-tag{
  background: var(--primary);
  color: #fff;
}
.no-offer-tag {
  background: var(--primary);
  color: #fff;
}
.font-size{
  color:var(--color-nickel);
  font-size: 1.5rem;
  font-weight: 300;
  margin: 10px 0px;
}
  h2.leads{
    margin:20px;
  }
.default-item .default-item-info {
  width: 100%;
  display: grid;
  grid:
    "name idnumber date stage button" auto
    / 1fr 1fr 1fr 1fr 1.5fr ;
  gap: 0rem 1rem;
  place-items: center;
  place-content: center stretch;
}
.header-btn {
  max-width: 1344px;
}
.search-leads {
  margin: auto;
  width: 100%;
}
.content-title {
  color: var(--primary);
  font-weight: 600;
}
.med-size-text {font-size: 0.9rem;}

@media (max-width: 800px) {
  .med-size-text {font-size: 0.75rem;}
}
@media (max-width: 570px) {
  .med-size-text {font-size: 0.9rem;}
  .default-item .default-item-info {
    grid:
      "name" auto
      "date" auto
      "stage" auto
      "button" auto
      / auto;
    place-content: center stretch;
  }
.button.is-fullwidth-mobile {
  display: flex;
  width: 100%;
  }
}
@media (max-width: 350px) {
  .med-size-text {font-size: 0.75rem;}
}

</style>
